const API = process.env.REACT_APP_BACKEND_URL;
const KEY = "aetheria-review-key";

async function j(r) {
  if (!r.ok) {
    let detail = r.statusText;
    try {
      const d = await r.json();
      detail = typeof d.detail === "string" ? d.detail : JSON.stringify(d.detail);
    } catch {
      /* no body */
    }
    const err = new Error(detail);
    err.status = r.status;
    throw err;
  }
  return r.json();
}

export const fetchApproved = (siteId, voterId) =>
  fetch(`${API}/api/theories/${siteId}${voterId ? `?voter_id=${voterId}` : ""}`).then(j);

export const reactTheory = (id, voterId) =>
  fetch(`${API}/api/theories/${id}/react`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ voter_id: voterId }),
  }).then(j);

export const fetchOrigins = () => fetch(`${API}/api/votes/origins`).then(j);

export const submitTheory = (payload) =>
  fetch(`${API}/api/theories`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }).then(j);

export const getReviewKey = () => sessionStorage.getItem(KEY) || "";
export const setReviewKey = (k) => (k ? sessionStorage.setItem(KEY, k) : sessionStorage.removeItem(KEY));

const auth = () => ({ "X-Review-Key": getReviewKey() });

export const reviewSummary = () => fetch(`${API}/api/theories/review/summary`, { headers: auth() }).then(j);
export const reviewList = (status) =>
  fetch(`${API}/api/theories/review?status=${status}`, { headers: auth() }).then(j);
export const reviewDecide = (id, decision) =>
  fetch(`${API}/api/theories/review/${id}/${decision}`, { method: "POST", headers: auth() }).then(j);

export const fetchPulse = () => fetch(`${API}/api/votes/pulse`).then(j);
